import React from 'react';
import ColorInput from './ColorInput';
import { GATE_REVEAL_EFFECTS, GATE_REVEAL_FONTS, getGateHighlight, getGateRevealAppearance } from '../utils/gatePresentation';

export default function GateRevealControls({ style = {}, onChange, ccStyles }) {
    const highlight = getGateHighlight(style);
    const appearance = getGateRevealAppearance(style);
    return <div>
        <label style={ccStyles.label}>Unlock panel colour
            <ColorInput value={appearance.panelColor} style={ccStyles.control}
                onChange={event => onChange({ '--gate-reveal-panel-color': event.target.value })} />
        </label>
        <label style={ccStyles.label}>Unlock font
            <select value={appearance.fontFamily} style={ccStyles.control}
                onChange={event => onChange({ '--gate-reveal-font': event.target.value })}>
                {GATE_REVEAL_FONTS.map(font => <option key={font} value={font}>{font}</option>)}
            </select>
        </label>
        <label style={ccStyles.label}>Unlock font colour
            <ColorInput value={appearance.textColor} style={ccStyles.control}
                onChange={event => onChange({ '--gate-reveal-text-color': event.target.value })} />
        </label>
        <label style={ccStyles.label}>Unlock effect
            <select value={appearance.effect} style={ccStyles.control}
                onChange={event => onChange({ '--gate-reveal-effect': event.target.value })}>
                {GATE_REVEAL_EFFECTS.map(effect => <option key={effect} value={effect}>{effect.charAt(0).toUpperCase() + effect.slice(1)}</option>)}
            </select>
        </label>
        <label style={ccStyles.label}>
            <span><input type="checkbox" checked={highlight.enabled}
                onChange={event => onChange({ '--gate-highlight-enabled': event.target.checked ? 'on' : 'off' })} /> Highlight panels ready to unlock</span>
        </label>
        {highlight.enabled && <>
            <label style={ccStyles.label}>Unlock glow colour
                <ColorInput value={highlight.color} style={ccStyles.control}
                    onChange={event => onChange({ '--gate-highlight-color': event.target.value })} />
            </label>
            <label style={ccStyles.label}>Unlock highlight pulse
                <select value={highlight.mode} style={ccStyles.control}
                    onChange={event => onChange({ '--gate-highlight-mode': event.target.value })}>
                    <option value="steady">Steady (no pulse)</option>
                    <option value="gentle">Gentle pulse</option>
                    <option value="breathe">Breathing glow</option>
                </select>
            </label>
            {highlight.mode !== 'steady' && <label style={ccStyles.label}>Unlock pulse duration
                <select value={highlight.duration} style={ccStyles.control}
                    onChange={event => onChange({ '--gate-highlight-duration': `${event.target.value}s` })}>
                    {[2, 3, 4, 6, 8].map(seconds => <option key={seconds} value={seconds}>{seconds} seconds</option>)}
                </select>
            </label>}
        </>}
        <p style={ccStyles.labelHint}>A green pulsing glow and confetti are enabled by default. Uncheck the highlight to turn the glow off. These colours and the font apply to the unlock panel; text sizes stay automatic. Random chooses an effect on each reveal. Reduced motion uses a steady glow without reveal animations.</p>
    </div>;
}
